//utils
import { displayErrorMessage } from '@insticator/insticator-ui';
//API calls
import { getCountries } from 'utils/api/home';


export const UPDATE_SELECTED_COUNTRIES = 'UPDATE_SELECTED_COUNTRIES';
export const UPDATE_SELECTED_SITES = 'UPDATE_SELECTED_SITES';
export const UPDATE_SELECTED_DEVICES = 'UPDATE_SELECTED_DEVICES';
export const UPDATE_DATE_RANGE = 'UPDATE_DATE_RANGE';
export const UPDATE_REVENUE_TYPE = 'UPDATE_REVENUE_TYPE';
export const CLEAR_HOME_CONTROLS = 'CLEAR_HOME_CONTROLS';
export const GET_COUNTRIES = "GET_COUNTRIES";



export const updateSelectedCountries = countries => ({
    type: UPDATE_SELECTED_COUNTRIES,
    countries
});

export const updateSelectedSites = sites => ({
    type: UPDATE_SELECTED_SITES,
    sites
});

export const updateSelectedDevices = devices => ({
    type: UPDATE_SELECTED_DEVICES,
    devices
});

export const updateDateRange = range => ({
    type: UPDATE_DATE_RANGE,
    range
});

export const updateSelectedRevenueType = revenueType => ({
    type: UPDATE_REVENUE_TYPE,
    revenueType
});

export const clearHomeControls = () => ({type: CLEAR_HOME_CONTROLS});

// -=-=-=-==- thunks to get dropdown data =-=-=-=-=-=-=-=- //

export const getAllCountries = ( paramString ) => dispatch => {
    return getCountries(paramString)
        .then(response => {
            return dispatch(receiveCountries(response.data))
        })
        .catch(err => dispatch(displayErrorMessage('There was an issue fetching your countries')) )
};

const receiveCountries = (countries) => ({type: GET_COUNTRIES,
    countries
});
